import { AnalyticsStore } from 'common/stores/AnalyticsStore';
import { MraidStore } from 'common/stores/MraidStore';
import { UserCloseHandler } from 'common/stores/handlers/UserCloseHandler';
import { DisplayConfigType } from '../config';

class ImageUserCloseHandler extends UserCloseHandler {}
class RedirectUserCloseHandler extends UserCloseHandler {
  handle(e: ClickEvent) {
    return super.handleMraid();
  }
}

export function getUserCloseHandler(props: {
  adContext: AdContext;
  mraidStore: MraidStore;
  analyticsStore: AnalyticsStore;
  formatName: FormatName;
  formatConfig: DisplayConfigType;
}) {
  if (props.adContext.creativeSource === 'redirect') {
    return new RedirectUserCloseHandler(props);
  }

  return new ImageUserCloseHandler(props);
}
